class Sizes {
  constructor({chest, inseam, jacketLength, neck, shoe, sleeve, waist}) {
    this.chest = chest
    this.inseam = inseam
    this.jacketLength = jacketLength
    this.neck = neck
    this.shoe = shoe
    this.sleeve = sleeve
    this.waist = waist
  }
}

export const EMPTY_SIZES = new Sizes({
  chest: undefined,
  inseam: undefined,
  jacketLength: undefined,
  neck: undefined,
  shoe: undefined,
  sleeve: undefined,
  waist: undefined,
})

export default Sizes
